/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Livid_Free_Larva_AriseInputs */

const fr_livid_free_larva_arise = /** @type {(inputs: Livid_Free_Larva_AriseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors du chargement de la tendance.`)
};

/**

* @param {Livid_Free_Larva_AriseInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const livid_free_larva_arise = /** @type {((inputs?: Livid_Free_Larva_AriseInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Livid_Free_Larva_AriseInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_livid_free_larva_arise(inputs)
});